<app-section-wrapper-container>
	<form
		class="um-section-parent-container"
		[formGroup]="detailsForm"
		(keypress)="onKeyPress($event)">
		<div>
			<app-single-dropdown
				formControlName="engineSizeUnit"
				[label]="'vehicles|record|engine-section|field-label|engine-size-unit'"
				[selectOptions]="engineSizeUnit" />
			<app-input-field
				formControlName="engineSize"
				[isNumber]="true"
				[label]="'vehicles|record|engine-section|field-label|engine-size'" />
		</div>
		<div>
			<app-single-dropdown
				formControlName="fuelTankCapacityUnit"
				[label]="
					'vehicles|record|engine-section|field-label|tank-capacity-unit'
				"
				[selectOptions]="fuelTankCapacityUnit" />
			<app-input-field
				formControlName="fuelTankCapacity"
				[isNumber]="true"
				[label]="'vehicles|record|engine-section|field-label|tank-capacity'" />
		</div>
		<div class="um-section-child-container items-end">
			<app-input-field
				formControlName="engineOutput"
				[isNumber]="true"
				[label]="'vehicles|record|engine-section|field-label|engine-output'" />
			<app-toggle-new
				[label]="'vehicles|record|engine-section|field-label|engine-turbine'"
				formControlName="engineTurbine" />
		</div>
	</form>
</app-section-wrapper-container>
